import { RootState } from "../../store";

export const accountAttemptIdSelector = (
  state: RootState,
): string | undefined => state.accountSetup?.accountAttempt?.id;
